import {Component, Inject, OnInit} from '@angular/core';
import {ConfService} from '../../conf.service';
import {ActivatedRoute} from '@angular/router';
import {MatDialog, MatSnackBar} from '@angular/material';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AttributesListComponent} from '../../attributes-list/attributes-list.component';
import {AddCatComponent} from '../category/category.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {AccountInfoService} from '../../user/account-info.service';

@Component({
  selector: 'app-provider-category',
  templateUrl: './provider-category.component.html',
  styleUrls: ['./provider-category.component.scss']
})
export class ProviderCategoryComponent implements OnInit {

  categories: any;
  title = 'Service Categories';
  cardType = 'provider';
  buttonType = 'provider';
  partner: any;
  account: any;
  flag = false;
  category_id: any;
  specificCategory: any;
  specificCategorytemp: any;
  categorytemp: any;
  producers: any;
  producersTemp: any;
  constructor(private route: ActivatedRoute,
              private confPost: ConfService,
              public dialog: MatDialog,
              public accountInfoService: AccountInfoService,
              public platform: LeftpanelComponent) { }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    this.confPost.getData('services', 'services', 'v1', 'producerCategories', 'partner=services,' + localStorage.getItem('partner') + '&account=services,' + localStorage.getItem('account')).subscribe(response => {
      this.categories = response;
      this.confPost.getData('services', 'services', 'v1', 'producerCategories', 'partner=services,' + localStorage.getItem('partner') + '&account=services,' + localStorage.getItem('account') + '&dbref=false').subscribe(response1 => {
        this.categorytemp = response1;
        this.route.queryParams.subscribe(params => {
          if (params.partner !== undefined && params.category !== undefined) {
            this.partner = params.partner;
            this.account = params.partner;
            this.category_id = params.category;
            for (let i = 0; i < this.categories.length; i++) {
              if (this.categories[i].id === parseInt(this.category_id, 10)) {
                this.specificCategory = this.categories[i];
              }
            }
            for (let i = 0; i < this.categorytemp.length; i++) {
              if (this.categorytemp[i].id === parseInt(this.category_id, 10)) {
                this.specificCategorytemp = this.categorytemp[i];
              }
            }
            this.specificCategory['currentServiceProvider'] = [];
            this.confPost.getData('services', 'services', 'v1', 'apiproducers', 'partner=services,' + localStorage.getItem('partner') + '&account=services,' + localStorage.getItem('account')).subscribe(response => {
              this.producers = response;
              this.producersTemp = JSON.parse(JSON.stringify(this.producers));
              let temp = [];
              let flag: boolean;
              let flag1: boolean;
              for (let k = 0; k < this.producersTemp.length; k++) {
                flag = false;
                flag1 = false;
                for (let i = 0; i < this.specificCategory.serviceProvider.length; i++) {
                  if (this.producersTemp[k].id === this.specificCategory.serviceProvider[i].id) {
                    flag = true;
                  }
                  if (this.producersTemp[k].id === this.specificCategory.serviceProvider[i].id
                      && this.producersTemp[k].account === this.specificCategory.serviceProvider[i].account
                      && this.producersTemp[k].partner === this.specificCategory.serviceProvider[i].partner
                      && this.producersTemp[k].account !== null && this.producersTemp[k].partner !== null) {
                    flag1 = true;
                  }
                }
                if (flag === false) {
                  temp.push(this.producersTemp[k]);
                }
                if (flag1) {
                  this.specificCategory.currentServiceProvider.push(this.producersTemp[k]);
                }
              }
              this.producers = temp;
              this.flag = true;
            });
          } else {
            this.category_id = '';
          }
        });
      });
    });
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
  openAddDialog() {
    const dialogRef = this.dialog.open(AddProdComponent, {
      data: this.producers,
      width: '80%'
      // data : []
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result.length > 0) {
          let temp = [];
          for ( let i = 0; i < result.length; i++ ) {
            this.specificCategorytemp.serviceProvider.push(result[i]);
          }
          this.confPost.patchEntityData('services', 'services', 'v1', 'producerCategories', this.specificCategory.id, this.specificCategorytemp).subscribe(  success => {
            alert('Succesfully Updated');
            window.location.reload();
          }, error => {
            alert('Some error occured. Please try again later');
          });
        }
      }
    });
  }
}

@Component({
  selector: 'app-add-prod',
  templateUrl: './add-prod.component.html',
  styleUrls: ['./add-prod.component.scss']
})
export class AddProdComponent implements OnInit {
  checked = [];
  cardType = 'checked';
  title = 'Select Services to add';
  buttonType = 'checked';
  constructor (public platform: LeftpanelComponent,
               public dialogRef: MatDialogRef <AddProdComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dialogRef.disableClose = true;
  }
  ngOnInit(): void {
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
  close() {
    this.dialogRef.close();
  }
  Save() {
    if(this.checked.length !== 0) {
      this.dialogRef.close(this.checked);
    } else {
      this.platform.openSnackBar('Please select the services to add', 'Error', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }
}
